export const getLambdaRoute = () => process.env.GATSBY_LAMBDA_ROUTE || process.env.DEPLOY_URL + "/.netlify/functions";